(() => {
  const STORAGE_KEY = 'balevien_wishlist_v1';

  /* =========================
     TEMEL FAVORİ İŞLEMLERİ
  ========================== */

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

    window.dispatchEvent(
      new CustomEvent('balevien:wishlist:change', {
        detail: { items }
      })
    );
  }

  function isFavorite(productId) {
    return getWishlist().some(
      item => String(item.id) === String(productId)
    );
  }

  function syncProductButtons(productId) {
    const active = isFavorite(productId);

    document
      .querySelectorAll(
        `.balevien-wishlist-button[data-product-id="${productId}"]`
      )
      .forEach(button => {
        button.classList.toggle('is-active', active);
        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
        button.setAttribute(
          'aria-label',
          active ? 'Favorilerden çıkar' : 'Favorilere ekle'
        );
      });
  }

  function showToast(message) {
    let toast = document.querySelector('.balevien-wishlist-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'balevien-wishlist-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('is-visible');

    clearTimeout(toast._timer);

    toast._timer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 1700);
  }

  /* =========================
     ÜRÜN KARTLARINA KALP EKLE
  ========================== */

  function mountWishlistButton(component) {
    const buttonArea =
      component.querySelector('.product-form-buttons');

    if (!buttonArea) return;

    if (
      buttonArea.querySelector('.balevien-wishlist-button')
    ) {
      return;
    }

    const productId = component.dataset.productId;
    const productUrl = component.dataset.productUrl || '';

    if (!productId) return;

    const card = component.closest('product-card');

    const title =
      card
        ?.querySelector('[ref="productTitleLink"]')
        ?.textContent
        ?.trim() || '';

    const imageElement = card?.querySelector('img');

    const image =
      imageElement?.currentSrc ||
      imageElement?.src ||
      '';

    const addToCartComponent =
      buttonArea.querySelector('add-to-cart-component');

    if (addToCartComponent) {
      const wrapper = addToCartComponent.parentElement;

      if (
        wrapper &&
        wrapper.parentElement === buttonArea
      ) {
        wrapper.classList.add('balevien-add-wrap');
      }
    }

    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'balevien-wishlist-button';
    button.dataset.productId = productId;

    button.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0
        L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78
        7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0
        0-7.78Z"/>
      </svg>
    `;

    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      let wishlist = getWishlist();

      const exists = wishlist.some(
        item => String(item.id) === String(productId)
      );

      if (exists) {
        wishlist = wishlist.filter(
          item => String(item.id) !== String(productId)
        );

        showToast('Favorilerden çıkarıldı');
      } else {
        wishlist.push({
          id: productId,
          url: productUrl,
          title,
          image
        });

        showToast('Favorilere eklendi');
      }

      saveWishlist(wishlist);
      syncProductButtons(productId);
    });

    buttonArea.appendChild(button);
    syncProductButtons(productId);
  }

  function mountAll(root = document) {
    root
      .querySelectorAll?.(
        'product-card product-form-component[data-product-id]'
      )
      .forEach(mountWishlistButton);
  }

  /* =========================
     FAVORİLERİM SAYFASI
  ========================== */

  function formatMoney(cents) {
    return (
      (Number(cents) / 100).toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' TL'
    );
  }

  function escapeHtml(value = '') {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  async function fetchProduct(item) {
    if (!item.url) {
      throw new Error('Ürün URL bulunamadı');
    }

    const cleanUrl =
      item.url.split('?')[0].replace(/\/$/, '');

    const response = await fetch(`${cleanUrl}.js`);

    if (!response.ok) {
      throw new Error('Ürün alınamadı');
    }

    return response.json();
  }

  function createFavoriteCard(item, product) {
    const firstAvailableVariant =
      product.variants?.find(variant => variant.available) ||
      product.variants?.[0];

    const price =
      firstAvailableVariant?.price ??
      product.price ??
      0;

    const compareAt =
      firstAvailableVariant?.compare_at_price ??
      product.compare_at_price ??
      0;

    const discounted =
      Number(compareAt) > Number(price);

    const productUrl =
      item.url || `/products/${product.handle}`;

    const image =
      product.featured_image ||
      item.image ||
      '';

    const hasMultipleVariants =
      (product.variants?.length || 0) > 1;

    return `
      <article class="balevien-favorite-card">

        <a
          href="${escapeHtml(productUrl)}"
          class="balevien-favorite-card__image"
        >
          <img
            src="${escapeHtml(image)}"
            alt="${escapeHtml(product.title)}"
            loading="lazy"
          >
        </a>

        <div class="balevien-favorite-card__body">

          <a
            href="${escapeHtml(productUrl)}"
            class="balevien-favorite-card__title"
          >
            ${escapeHtml(product.title)}
          </a>

          <div
            class="balevien-jdgm-api-badge"
            data-product-handle="${escapeHtml(product.handle)}"
          ></div>

          <div class="balevien-favorite-card__price">
            <span class="${discounted ? 'is-sale' : ''}">
              ${formatMoney(price)}
            </span>

            ${
              discounted
                ? `<del>${formatMoney(compareAt)}</del>`
                : ''
            }
          </div>

          <div class="balevien-favorite-card__actions">

            ${
              !firstAvailableVariant?.available
                ? `
                  <button
                    class="balevien-favorite-add"
                    disabled
                  >
                    Tükendi
                  </button>
                `
                : hasMultipleVariants
                  ? `
                    <a
                      href="${escapeHtml(productUrl)}"
                      class="balevien-favorite-add"
                    >
                      Seçenekleri Gör
                    </a>
                  `
                  : `
                    <button
                      type="button"
                      class="balevien-favorite-add"
                      data-favorite-variant-id="${firstAvailableVariant.id}"
                    >
                      Sepete Ekle
                    </button>
                  `
            }

            <button
              type="button"
              class="balevien-favorite-remove"
              data-remove-favorite="${escapeHtml(item.id)}"
              aria-label="Favorilerden çıkar"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0
                L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78
                7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0
                0-7.78Z"/>
              </svg>
            </button>

          </div>
        </div>
      </article>
    `;
  }

  async function addVariantToCart(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Sepete eklenemedi');
      }

      showToast('Sepete eklendi');

      /*
        Cart drawer / sayaç tarafının güncellenmesi için
        Shopify sayfasına standart değişiklik sinyali.
      */
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true
        })
      );

    } catch (error) {
      console.error('Balevien favori sepet:', error);
      showToast('Sepete eklenemedi');
    }
  }

async function renderWishlistPage() {

  /* Sadece Favorilerim sayfasında çalış */
  if (
    window.location.pathname !== '/pages/favorilerim' &&
    window.location.pathname !== '/pages/favorilerim/'
  ) {
    return;
  }

  const container =
    document.querySelector(
      '[data-balevien-wishlist-page]'
    );

  if (!container) return;

    const wishlist = getWishlist();

    if (!wishlist.length) {
      container.innerHTML = `
        <div class="balevien-wishlist-empty">
          <div class="balevien-wishlist-empty__heart">♡</div>

          <h2>Henüz favoriniz yok</h2>

          <p>
            Beğendiğiniz ürünlerdeki kalp simgesine
            dokunarak onları burada saklayabilirsiniz.
          </p>

          <a
            href="/collections/all"
            class="balevien-wishlist-empty__link"
          >
            Ürünleri Keşfet
          </a>
        </div>
      `;

      return;
    }

    container.innerHTML = `
      <div class="balevien-wishlist-loading">
        Favorileriniz hazırlanıyor...
      </div>
    `;

    const cards = await Promise.all(
      wishlist.map(async item => {
        try {
          const product = await fetchProduct(item);
          return createFavoriteCard(item, product);
        } catch (error) {
          console.warn(
            'Favori ürün yüklenemedi:',
            item,
            error
          );
          return '';
        }
      })
    );

    container.innerHTML = `
      <div class="balevien-wishlist-grid">
        ${cards.join('')}
      </div>
    `;

    container
      .querySelectorAll('[data-remove-favorite]')
      .forEach(button => {
        button.addEventListener('click', () => {
          const productId =
            button.dataset.removeFavorite;

          const newWishlist =
            getWishlist().filter(
              item =>
                String(item.id) !==
                String(productId)
            );

          saveWishlist(newWishlist);
          syncProductButtons(productId);
          renderWishlistPage();

          showToast('Favorilerden çıkarıldı');
        });
      });

    container
      .querySelectorAll('[data-favorite-variant-id]')
      .forEach(button => {
        button.addEventListener('click', async () => {
          const variantId =
            button.dataset.favoriteVariantId;

          const originalText = button.textContent;

          button.disabled = true;
          button.textContent = 'Ekleniyor...';

          await addVariantToCart(variantId);

          button.disabled = false;
          button.textContent = originalText;
        });
      });

    /*
      Favoriler sayfasındaki kartlarda da
      Judge.me yıldızlarımız yüklensin.
    */
    document.dispatchEvent(
      new Event('shopify:section:load')
    );
  }

  /* =========================
     BAŞLAT
  ========================== */

  function init() {
    mountAll();
    renderWishlistPage();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          mountAll(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      mountAll(event.target);
    }
  );

  window.addEventListener('pageshow', () => {
    mountAll();
  });
})();